<template>
  <section class="invoice-preview-wrapper">
    <asset-options v-if="user.role != 'SIMPlVI'" :myId="myId" :deviceId="deviceId" @event-block="openModalSetBlock"
                   @event-criterion="toVirtualFence" @event-point="toPoint" :has-block="hasBlock"/>
    <b-row class="justify-content-between">
      <b-col class="d-flex align-items-center mb-2">
        <feather-icon v-if="plan && plan.id" :icon="assetPlanIcon" class="text-primary mr-50" size="16"/>
        <p class="m-0 text-primary font-weight-bold text-header flex-fill">{{ plate != '' ? plate : chassisNumber }}</p>
        <b-button @click="toAssetSummary()" class="ml-sm-1"  variant="outline-primary" size="sm">{{$t('New View')}}</b-button>

      </b-col>
    </b-row>
    <b-row>
      <b-col xl="6" md="6" sm="12">

        <card-info heightImg="198px" :customerName="customerName"
                   :model="`${modelName} - ${modelYear}`" :chassis="`${plate ? plate : chassisNumber}`"
                   :status="`${lastWorkStatus ? lastWorkStatus : `noconnection`}`" :urlImage="imageicon"
                   :is-blocked="isBlocked" :dealerName="dealer" :panic="panic" :last-connection="lastConnectionTime"
                   :modem-identifier="deviceModemIdentifier" :asset-id="myId"/>
        <b-card style="height: 550px;">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <h5 class="my-0 custom-h5"> <span class="custom-h5">{{ $t('Last Position') }}:
                                {{ lastPositionTime.includes('31/12/1969 - 21:00') ? $t('Not Reported') : lastPositionTime }}</span></h5>
            <b-button :title="$t('Go to Google Maps')" size="sm" variant="info"
                      @click="toGoogleMap()">
              <feather-icon icon="MapPinIcon" size="16"/>
            </b-button>
          </div>
          <l-map ref="myMap" id="myMap" :style="[{ maxHeight: mapMaxHeight }, { minHeight: mapMinHeight }]"
                 :zoom="zoom" :center="center">
            <l-tile-layer :url="url"></l-tile-layer>
            <l-control>
              <!-- size -->
              <b-button-group size="sm">
                <b-button variant="light" :pressed="btnMap" @click="chooseLayer('map')">
                  Map
                </b-button>
                <b-button variant="light" :pressed="btnGround" @click="chooseLayer('ground')">
                  Ground
                </b-button>
                <b-button variant="light" :pressed="btnHybrid" @click="chooseLayer('hybrid')">
                  Hybrid
                </b-button>
              </b-button-group>
            </l-control>
            <l-marker v-if="latLong != [0, 0]" :lat-lng="latLong">
              <l-icon :class-name="`someExtraClass asset-${lastWorkStatus} `" :icon-size="dynamicSize"
                      :tooltip-anchor="dynamicTooltip" :popup-anchor="dynamicPopup" :icon-anchor="dynamicAnchor">
                <img class="with-icon" :src="imageicon">
              </l-icon>
            </l-marker>
          </l-map>
        </b-card>
      </b-col>
      <b-col xl="6" md="6" sm="12">
        <status-card :dataWorkStatus="dataWorkStatus" :assetId="myId"/>
        <b-row v-show="assetType != 28">
          <b-col
              v-if="telemetrySummaryLoading"
              cols="12"
              class="d-flex justify-content-center py-2"
          >
            <b-spinner small type="grow" variant="primary"/>
          </b-col>
          <template v-if="hasTelemetryCards">
            <b-col
                v-for="card in telemetryCards"
                :key="card.code"
                xl="4"
                md="4"
                sm="6"
                class="mb-1"
            >
              <simple-indicator-card
                  v-if="card.component === 'simple'"
                  :title="card.title"
                  :icon="card.icon"
                  :statistic="card.value"
                  :statistic-title="card.unit"
                  :color="card.color"
                  :timestamp="card.timestamp"
              />
              <simple-gauge-indicator
                  v-else
                  :fuel="card.value"
                  :timestamp="card.timestamp"
              />
            </b-col>
          </template>
          <b-col
              v-else-if="!telemetrySummaryLoading"
              cols="12"
              class="mt-1"
          >
            <b-alert variant="light" show>
              {{ $t('Not Reported') }}
            </b-alert>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="6" md="6" sm="12">
        <b-row v-show="assetType == 28 && deviceId">
          <b-col md="12">
            <card-send-commands :model="`${modelName}`" :identifier="`${plate != '' ? plate : chassisNumber}`"
                                :input01="in1" :input02="in2" :input03="in3" :input04="in4" :output01="out1"
                                :output02="out2"
                                :output03="out3" :output04="out4" :inputRange01="inputRange01"
                                :isLoadingOut1="isLoadingOut1"
                                :ssd="ssd" :sse="sse" :isLoadingGlobal="isLoadingGlobal" :isLoadingOut2="isLoadingOut2"
                                :isLoadingOut3="isLoadingOut3" :isLoadingRange01="isLoadingRange01"
                                @emit-send-command="handleSendCommand"/>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-card v-if="user.role != 'SIMPlVI'" no-body class="p-1">

      <b-card-body>
        <b-row class="mb-3 ml-25">
          <b-col cols="12" md="4" class="mb-md-0 mb-3">
            <label>{{ $t('Choose the Date') }}</label>
            <flat-pickr v-model="date" class="form-control"/>
          </b-col>
        </b-row>

        <b-row v-show="noMatchin" class=" ml-25">
          <b-col cols="12" md="6" class="mb-md-0 mb-3 ml-25 pt-2">
            <h4>{{ $t('No matching records found') }}</h4>
          </b-col>
        </b-row>


        <b-row v-if="timeConnectionRpm.length > 0 && rpmHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="r/min" :title="$t('RPM')"
                                     :axisX="timeConnectionRpm" :axisY="rpmHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionEngine.length > 0 && engineHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="ºC" :title="$t('Engine Temperature')"
                                     :axisX="timeConnectionEngine" :axisY="engineHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionOil.length > 0 && oilHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="ºC" :title="$t('Hydraulic Oil Temperature')"
                                     :axisX="timeConnectionOil" :axisY="oilHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionTransmission.length > 0 && transmissionHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="ºC" :title="$t('Transmission Temperature')"
                                     :axisX="timeConnectionTransmission" :axisY="transmissionHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionCbc.length > 0 && cbcHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="L/h" :title="$t('Average Fuel Consumption')"
                                     :axisX="timeConnectionCbc" :axisY="cbcHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionCbt.length > 0 && cbtHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="%" :title="$t('Level Fuel')"
                                     :axisX="timeConnectionCbt" :axisY="cbtHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>


        <!-- New charts -->
        <b-row v-if="timeConnectionPcb.length > 0 && pcbHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="kPa" :title="$t('Fuel Pressure')"
                                     :axisX="timeConnectionPcb" :axisY="pcbHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionPom.length > 0 && pomHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="kPa" :title="$t('Engine Oil Pressure')"
                                     :axisX="timeConnectionPom" :axisY="pomHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionPtb.length > 0 && ptbHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="kPa" :title="$t('Turbo Pressure')"
                                     :axisX="timeConnectionPtb" :axisY="ptbHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionTbt.length > 0 && tbtHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="Volts" :title="$t('Battery Voltage')"
                                     :axisX="timeConnectionTbt" :axisY="tbtHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionTtb.length > 0 && ttbHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="Volts" :title="$t('Battery Voltage')" icon="InfoIcon"
                                     :axisX="timeConnectionTtb" :axisY="ttbHistory" :temperature="`${getTelemetryValue('ttb', '')}`"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionAcl.length > 0 && aclHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="G" :title="$t('Acceleration')"
                                     :axisX="timeConnectionAcl" :axisY="aclHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionKmh.length > 0 && kmhHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="Km/h" :title="$t('Speed')"
                                     :axisX="timeConnectionKmh" :axisY="kmhHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionCgm.length > 0 && cgmHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="%" :title="$t('Engine Load')"
                                     :axisX="timeConnectionCgm" :axisY="cgmHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>
        <b-row v-if="timeConnectionSoc.length > 0 && socHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="%" :title="$t('Power Battery Charge')"
                                     :axisX="timeConnectionSoc" :axisY="socHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>
        <b-row v-if="timeConnectionTpb.length > 0 && tpbHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="ºC" :title="$t('Power Battery Temperature')"
                                     :axisX="timeConnectionTpb" :axisY="tpbHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>
        <b-row v-if="timeConnectionTom.length > 0 && tomHistory.length > 0">
          <!-- Inicio componente CompleteIndicator -->
          <b-col xl="12" md="12" sm="12">
            <complete-indicator-card unity="ºC" :title="$t('Engine oil temperature')"
                                     :axisX="timeConnectionTom" :axisY="tomHistory"
                                     :use-date-time-scale="true" />
          </b-col>
        </b-row>

        <!-- Gráficos de Colunas -->
        <b-row v-if="timeConnectionCab.length > 0 && cabHistory.length > 0">
          <b-col xl="12" md="12" sm="12">
            <bar-chart-card 
              unity="" 
              :title="$t('Harsh Acceleration Count')" 
              icon="WindIcon"
              :axisX="timeConnectionCab" 
              :axisY="cabHistory"
              currentValue=""
              variant="light-warning"
              color="warning"
            />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionMkm.length > 0 && mkmHistory.length > 0">
          <b-col xl="12" md="12" sm="12">
            <bar-chart-card 
              unity="" 
              :title="$t('Maximum Speed on Route')" 
              icon="ActivityIcon"
              :axisX="timeConnectionMkm" 
              :axisY="mkmHistory"
              currentValue=""
              variant="light-info"
              color="info"
            />
          </b-col>
        </b-row>

        <b-row v-if="timeConnectionCfb.length > 0 && cfbHistory.length > 0">
          <b-col xl="12" md="12" sm="12">
            <bar-chart-card 
              unity="" 
              :title="$t('Harsh Braking Count')" 
              icon="ChevronsLeftIcon"
              :axisX="timeConnectionCfb" 
              :axisY="cfbHistory" 
              currentValue=""
              variant="light-primary"
              color="primary"
            />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-modal ref="modal-block" size="md" hide-footer centered>
      <div class="d-block text-center">
        <h3>{{ isBlocked ? $t('Do you want to deactivate the block?') : $t('Do you want to activate the block?') }}</h3>
      </div>
      <div class="d-flex justify-content-center text-center">
        <button type="button" class="btn btn-secondary mr-50" @click="hideModalSetBlock">
          {{ $t('Close') }}
        </button>
        <button type="button" class="btn btn-primary ml-50" @click="toogleBlock">
          {{ isBlocked ? $t('Deactivate Block') : $t('Activate Block') }}
        </button>
      </div>
    </b-modal>

  </section>
</template>

<script>
import {
  ref,
  onUnmounted,
  computed
} from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
  BImg,
  BButtonGroup,
  BModal,
  BSpinner,
} from 'bootstrap-vue'
import Logo from '@core/layouts/components/Logo.vue'
import Ripple from 'vue-ripple-directive'
import assetStoreModule from '../assetStoreModule'
import { resolveIcon } from '@/utils/assetUtils'
import { processTelemetryData, telemetryParameterMap } from '@/utils/telemetryParametersUtils'

import SimpleIndicatorCard from '../asset-preview/indicators/SimpleIndicatorCard.vue'
import SimpleGaugeIndicator from '../asset-preview/indicators/SimpleGaugeIndicator.vue'
import CompleteIndicatorCard from '../asset-preview/indicators/CompleteIndicatorCard.vue'
import BarChartCard from '../asset-preview/indicators/BarChartCard.vue'
import CardInfo from '../asset-preview/indicators/CardInfo.vue'
import CardSendCommands from "@/views/main/asset/asset-preview/indicators/CardSendCommands.vue";
import StatusCard from '../asset-preview/indicators/StatusCard.vue'

import AssetOptions from "../../components/AssetOptions.vue";

import flatPickr from 'vue-flatpickr-component'

import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LPopup,
  LControl,
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import {
  latLng,
  icon,
  Icon
} from 'leaflet'
import L from 'leaflet';

import BCardCode from '@core/components/b-card-code/BCardCode.vue'

import signalrHub from '@core/signalr/signalrHub.js'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    Logo,
    BImg,
    BButtonGroup,
    flatPickr,
    BModal,
    BSpinner,

    SimpleIndicatorCard,
    SimpleGaugeIndicator,
    CompleteIndicatorCard,
    BarChartCard,
    CardInfo,
    CardSendCommands,

    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    LControl,

    BCardCode,
    StatusCard,
    AssetOptions
  },
  data() {
    return {
      deviceModemIdentifier: '',
      showModal: false,
      btnGround: false,
      btnMap: true,
      btnHybrid: false,
      date: ``,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 4,
      center: [-10.1500034, -67.9163393],
      icon: L.icon({

        iconSize: [32, 37],
        iconAnchor: [16, 37]
      }),
      staticAnchor: [16, 37],

      iconSize: 40,
      marker: {
        latLong: [0, 0],

      },
      mapHeight: '45vh',
      mapMaxHeight: '470px',
      mapMinHeight: '470px',
      teste: '50',
      mostrar: false,

      //Data fetchAsset
      chassisNumber: "",
      color: "",
      customerId: "",
      engineNumber: null,
      id: "",
      modelName: "",
      modelYear: 0,
      nickname: "",
      plate: "",
      assetType: ``,
      customerName: ``,
      dealer: '',
      hasBlock: false,

      //Data fetchAssetSummary
      lastConnectionTime: '',
      lastPositionTime: '',
      lastTelemetryTime: '',
      lastTelemetry: '',
      lastWorkStatus: '',
      latLong: [0, 0],

      //Data fetchAssetTelemetry
      telemetryParameters: [],
      timeConnectionVel: [],
      velHistory: [],
      timeConnectionEngine: [],
      engineHistory: [],
      timeConnectionTransmission: [],
      transmissionHistory: [],
      timeConnectionOil: [],
      oilHistory: [],
      timeConnectionCbc: [],
      cbcHistory: [],
      timeConnectionCbt: [],
      cbtHistory: [],
      timeConnectionRpm: [],
      rpmHistory: [],

      in1: false,
      in2: false,
      in3: false,
      in4: false,

      imageicon: '',
      loadingHistory: false,

      // Data fetchAssetWorkStatus
      //dataWorkStatus:[],

      deviceId: '',
      inputRange01: 0,
      out1: false,
      out2: false,
      out3: false,
      out4: false,

      oldInputRange01: 0,
      oldOldOut1: false,
      oldOut2: false,
      oldOut3: false,

      isLoadingOut1: false,
      isLoadingOut2: false,
      isLoadingOut3: false,
      isLoadingGlobal: false,
      isLoadingRange01: false,

      sse: false,
      ssd: false,

      panic: false,

      timeConnectionPcb: [],
      pcbHistory: [],
      pomHistory: [],
      timeConnectionPom: [],
      ptbHistory: [],
      timeConnectionPtb: [],
      tbtHistory: [],
      timeConnectionTbt: [],
      aclHistory: [],
      timeConnectionAcl: [],
      kmhHistory: [],
      timeConnectionKmh: [],
      cgmHistory: [],
      timeConnectionCgm: [],
      ttbHistory: [],
      timeConnectionTtb: [],
      socHistory: [],
      timeConnectionSoc: [],
      tpbHistory: [],
      timeConnectionTpb: [],
      tomHistory: [],
      timeConnectionTom: [],
      cabHistory: [],
      timeConnectionCab: [],
      mkmHistory: [],
      timeConnectionMkm: [],
      cfbHistory: [],
      timeConnectionCfb: [],


      planIcons: {
        1: "ZapIcon",
        2: "StarIcon",
        3: "AwardIcon"
      },

      waitingCommandResponse: false,
      isBlocked: false
    };
  },
  computed: {
    dynamicSize() {
      this.toltipAnchor = [27, 30];
      return [this.iconSize, this.iconSize * 1.15];
    },
    dynamicAnchor() {
      if (this.selectedIcon == true) {
        return [27, 30];
      } else {
        return [15, 13];
      }
    },
    dynamicTooltip() {
      if (this.selectedIcon == true) {
        return [25, 0];
      } else {
        return [7, -15];
      }
    },
    dynamicPopup() {
      if (this.selectedIcon == true) {
        return [2, -27];
      } else {
        return [-7, -13];
      }
    },

    noMatchin() {
      if (this.loadingHistory == false &&
          this.timeConnectionTransmission.length == 0 && this.transmissionHistory.length == 0 &&
          this.timeConnectionOil.length == 0 && this.oilHistory.length == 0 &&
          this.timeConnectionEngine.length == 0 && this.engineHistory.length == 0 &&
          this.timeConnectionVel.length == 0 && this.velHistory.length == 0 &&
          this.timeConnectionCbt.length == 0 && this.cbtHistory.length == 0 &&
          this.timeConnectionCbc.length == 0 && this.cbcHistory.length == 0 &&
          this.timeConnectionRpm.length == 0 && this.rpmHistory.length == 0 &&

          this.timeConnectionPcb.length == 0 &&
          this.pcbHistory.length == 0 &&
          this.pomHistory.length == 0 &&
          this.timeConnectionPom.length == 0 &&
          this.ptbHistory.length == 0 &&
          this.timeConnectionPtb.length == 0 &&
          this.tbtHistory.length == 0 &&
          this.timeConnectionTbt.length == 0 &&
          this.aclHistory.length == 0 &&
          this.timeConnectionAcl.length == 0 &&
          this.kmhHistory.length == 0 &&
          this.timeConnectionKmh.length == 0 &&
          this.cgmHistory.length == 0 &&
          this.timeConnectionCgm.length == 0 &&
          this.ttbHistory.length == 0 && this.timeConnectionTtb.length == 0 &&
          this.socHistory.length == 0 && this.timeConnectionSoc == 0 &&
          this.tpbHistory.length == 0 && this.timeConnectionTpb == 0 &&
          this.tomHistory.length == 0 && this.timeConnectionTom == 0 &&
          this.cabHistory.length == 0 && this.timeConnectionCab.length == 0 &&
          this.mkmHistory.length == 0 && this.timeConnectionMkm.length == 0 &&
          this.cfbHistory.length == 0 && this.timeConnectionCfb.length == 0
      ) {
        return true
      }
      return false
    },
    assetPlanIcon() {
      if (!this.plan?.id) return undefined
      return this.planIcons[this.plan.id]
    },
  },
  created() {
    const ASSET_APP_STORE_MODULE_NAME = 'app-asset'
    const dts = new Date();

    dts.setHours(0);
    dts.setMinutes(0);

    const dtf = new Date();
    dtf.setHours(23);
    dtf.setMinutes(59);

    // Register module
    if (!store.hasModule(ASSET_APP_STORE_MODULE_NAME)) store.registerModule(ASSET_APP_STORE_MODULE_NAME, assetStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ASSET_APP_STORE_MODULE_NAME)) store.unregisterModule(ASSET_APP_STORE_MODULE_NAME)
    })

    // fetchAsset
    store
        .dispatch('app-asset/fetchAsset', {
          id: router.currentRoute.params.id

        })
        .then(response => {

          response.data.devices.forEach(device => {
            this.deviceModemIdentifier = this.deviceModemIdentifier + ` ${device.modemIdentifier}`
          })
          this.dealer = response.data.dealerName
          this.customerName = response.data.ownerName

          this.chassisNumber = response.data.chassisNumber;
          this.color = response.data.color;

          this.engineNumber = response.data.engineNumber;

          this.modelName = response.data.modelIdName != '' ? response.data.modelIdName : response.data.modelName;
          this.modelYear = response.data.modelYear;
          this.nickname = response.data.nickname;
          this.plate = response.data.plate;
          this.assetType = response.data.assetType;
          this.hasBlock = response.data.hasBlock

          this.imageicon = this.resolveIcon(this.assetType, response.data.iconUrl);

          const identifier = response.data.plate ? response.data.plate : response.data.chassisNumber
          //this.getDeviceId(identifier)
          this.deviceId = response.data.devices[0].id

          this.plan = response.data.plan
        })
        .catch(() => {})

    this.fetchAssetSummary()


    // fetchAssetTelemetryParameters
    store.dispatch('app-asset/fetchAssetTelemetryParameters', {
      id: router.currentRoute.params.id
      //id: '365c7968-6bfd-4310-a6f8-b6f9fe2ffd2d'
    })
        .then(res => {
          this.telemetryParameters = res.data;
          const month = dts.getMonth() + 1
          this.date = `${dts.getFullYear()}-${month}-${dts.getDate()}`;
          this.fetchTelemetrySummary()

        })
        .catch(() => {})

  },
  mounted() {
    this.registerEventBusListeners();
    if (localStorage.layerPreview) {
      this.chooseLayer(localStorage.layerPreview)
    }


  },
  beforeDestroy() {

    this.deregisterEventBusListeners();
    clearInterval(this.interval);
  },

  watch: {
    date(newQuestion, oldQuestion) {
      this.fetchHistoric()
    }
  },
  methods: {
    updateIoFromTelemetry(telemetry) {
      if (!telemetry || typeof telemetry !== 'object') return;

      if (telemetry.in1 === false || telemetry.in1 === true || telemetry.in1 === 0 || telemetry.in1 === 1) {
        this.in1 = telemetry.in1;
      }
      if (telemetry.in2 === false || telemetry.in2 === true || telemetry.in2 === 0 || telemetry.in2 === 1) {
        this.in2 = telemetry.in2;
      }
      if (telemetry.in3 === false || telemetry.in3 === true || telemetry.in3 === 0 || telemetry.in3 === 1) {
        this.in3 = telemetry.in3;
      }
      if (telemetry.in4 === false || telemetry.in4 === true || telemetry.in4 === 0 || telemetry.in4 === 1) {
        this.in4 = telemetry.in4 === 0 ? false : Boolean(telemetry.in4);
      }
      if (telemetry.ou1 === false || telemetry.ou1 === true || telemetry.ou1 === 0 || telemetry.ou1 === 1) {
        this.out1 = telemetry.ou1;
        this.oldOldOut1 = this.out1;
        this.isBlocked = telemetry.ou1 === 1;
      }
      if (telemetry.ou2 === false || telemetry.ou2 === true || telemetry.ou2 === 0 || telemetry.ou2 === 1) {
        this.out2 = telemetry.ou2;
        this.oldOldOut2 = this.out2;
      }
      if (telemetry.ou3 === false || telemetry.ou3 === true || telemetry.ou3 === 0 || telemetry.ou3 === 1) {
        this.out3 = telemetry.ou3;
        this.oldOldOut3 = this.out3;
      }
      if (telemetry.ou4 !== undefined && telemetry.ou4 !== null) {
        this.inputRange01 = telemetry.ou4;
        this.oldInputRange01 = this.inputRange01;
      }
    },

    openModalSetBlock() {
      this.$refs['modal-block'].show()
    },
    hideModalSetBlock() {
      this.$refs['modal-block'].hide()
    },
    toogleBlock() {

      let command = {
        deviceId: this.deviceId,
        commandTypeId: 7,
        data: `${1}=${this.isBlocked ? 0 : 1}`
      }
      store.dispatch('app-asset/sendDeviceTelecommand', command)
          .then(response => {
            this.msgDialog(this.$t('Command sent'), "info", "")
            // if (port == 1) this.isLoadingOut1 = false
            // if (port == 2) this.isLoadingOut2 = false
            // if (port == 3) this.isLoadingOut3 = false
          })
          .catch(() => {})
      this.hideModalSetBlock()
      //this.isBlocked = !this.isBlocked

    },


    tryFixDecimalNumbers(number) {
      try {
        return parseFloat(number.toFixed(2));
      } catch (error) {
        return number;
      }
    },
    colorForPanelFailureCode(failureType) {
      if (!this.plan?.id || this.plan.id <= 1) return 'info'

      if (failureType == 2) return 'warning'
      if (failureType == 3) return 'danger'
      return 'info'
    },
    iconForPanelFailureCode(failureType) {
      if (!this.plan?.id || this.plan.id <= 1) return 'InfoIcon'

      if (failureType == 2) return 'AlertTriangleIcon'
      if (failureType == 3) return 'XOctagonIcon'
      return 'InfoIcon'
    },

    toGoogleMap() {
      var url = "https://www.google.com/maps?q=" + this.latLong[0] + "," + this.latLong[1];
      window.open(url, '_blank');

    },

    msgDialog(msg, icon, text) {
      this.$swal({
        position: 'top-end',
        icon: icon,
        title: msg,
        text: text,
        showConfirmButton: false,
        timer: 1500 * 2,
        customClass: {
          confirmButton: 'btn btn-primary',
        },

        buttonsStyling: false,
      })
    },

    fetchAssetSummary() {
      store
          .dispatch('app-asset/fetchAssetSummary', {
            id: router.currentRoute.params.id

          })
          .then(response => {

            if (response.data.lastTelemetry != null) {

              if (this.waitingCommandResponse) {
                this.resetLoadings()
                this.msgDialog(this.$t('An unexpected error occurred while fetching telemetry.'), "error", this.$t('Failed to communicate with satellite'))
                this.waitingCommandResponse = false
              }

              const lastTelemetry = response.data.lastTelemetry

              if (Object.prototype.hasOwnProperty.call(lastTelemetry, 'pan')) {
                this.panic = lastTelemetry.pan
              }

              this.updateIoFromTelemetry(lastTelemetry)
            }

            this.lastConnectionTime = this.formatDate(response.data.lastConnectionTime);
            //this.lastPositionTime = new Date(response.data.lastPositionTime).toLocaleString().substring(0, 16);
            this.lastPositionTime = this.formatDate(response.data.lastPositionTime)
            //this.lastTelemetryTime= new Date(response.data.lastTelemetryTime);
            if (response.data.lastWorkStatus) this.lastWorkStatus = response.data.lastWorkStatus;
            if (response.data.lastLat && response.data.lastLat != 0 && response.data.lastLng && response.data.lastLng != 0) {
              this.latLong = [response.data.lastLat, response.data.lastLng]

              this.$nextTick(() => {
                this.$refs.myMap.mapObject.setView(this.latLong, 17);
                //this.$refs.myMap.mapObject.setView(this.latLong);

              })

            }

          })
          .catch(() => {})
    },


    sendCommands(port, value) {
      this.isLoadingGlobal = true
      if (port == 1) this.isLoadingOut1 = true
      if (port == 2) this.isLoadingOut2 = true
      if (port == 3) this.isLoadingOut3 = true
      if (port == 4) this.isLoadingRange01 = true

      //let val = 0

      // if (port == 4) {
      //     val = value
      // } else {
      //     val = value == true ? 1 : 0
      // }

      let command = {
        deviceId: this.deviceId,
        commandTypeId: 7,
        data: `${port}=${value}`
      }


      store.dispatch('app-asset/sendDeviceTelecommand', command)
          .then(response => {

            // if (port == 1) this.isLoadingOut1 = false
            // if (port == 2) this.isLoadingOut2 = false
            // if (port == 3) this.isLoadingOut3 = false
          })
          .catch(() => {})
    },

    resetLoadings() {
      this.isLoadingGlobal = false
      this.isLoadingOut2 = false
      this.isLoadingOut3 = false
      this.isLoadingRange01 = false
      this.isLoadingOut1 = false
    },

    sendBulkDeviceTelecommand() {
      this.isLoadingGlobal = true

      let ou1 = this.out1 ? 1 : 0
      let ou2 = this.out2 ? 1 : 0
      let ou3 = this.out3 ? 1 : 0

      let command = {
        deviceId: this.deviceId,
        commands: [
          {
            commandTypeId: 7,
            data: `1=${ou1}`
          },
          {
            commandTypeId: 7,
            data: `2=${ou2}`
          },
          {
            commandTypeId: 7,
            data: `3=${ou3}`
          },
          {
            commandTypeId: 7,
            data: `4=${this.inputRange01}`
          }
        ]
      }
      this.waitingCommandResponse = true

      let self = this
      setTimeout(function () {
        self.fetchAssetSummary()
      }, 330000);


      store.dispatch('app-asset/sendBulkDeviceTelecommand', command)
          .then(response => {
          })
          .catch(() => {})
    },

    handleInput01Clicked(checked) {
      this.out1 = !this.out1
      this.sendCommands(1, checked)
    },
    handleInput02Clicked(checked) {
      this.out2 = !this.out2
      this.sendCommands(2, checked)
    },
    handleInput03Clicked(checked) {
      this.out3 = !this.out3
      this.sendCommands(3, checked)
    },
    handleInput04Clicked(checked) {
    },
    handleInputRange01Clicked(val) {
      this.inputRange01 = Math.round(val)

      if (this.inputRange01 < 0 || this.inputRange01 > 100) {
        this.msgDialog(this.$t('Input out of range'), 'info', this.$t('The range must be between 0 and 100'))
        return
      }

      this.sendCommands(4, this.inputRange01)
      //sendCommands(4, val)
    },

    handleSendCommand(val) {
      this.inputRange01 = Math.round(val.ou4)

      if (this.inputRange01 < 0 || this.inputRange01 > 100) {
        this.msgDialog(this.$t('Input out of range'), 'info', this.$t('The range must be between 0 and 100'))
        return
      }

      this.out1 = val.ou1
      this.out2 = val.ou2
      this.out3 = val.ou3

      let command = {
        ou1: this.out1,
        ou2: this.out2,
        ou3: this.out3,
        ou4: this.inputRange01,
      }
      this.sendBulkDeviceTelecommand()
    },

    toVirtualFence() {
      var center = this.$refs.myMap.mapObject.getCenter()
      var zoom = this.$refs.myMap.mapObject.getZoom()


      router.push({
        name: 'fence-register',
        query: {
          criterion: {
            zoom: zoom,
            lat: center.lat,
            lng: center.lng
          }
        }
      })
    },
    toPoint() {
      var center = this.$refs.myMap.mapObject.getCenter()
      var zoom = this.$refs.myMap.mapObject.getZoom()


      router.push({
        name: 'point-register',
        query: {
          criterion: {
            zoom: zoom,
            lat: center.lat,
            lng: center.lng
          }
        }
      })
    },

    chooseLayer(url) {
      localStorage.layerPreview = url;

      if (url == `ground`) {
        this.btnGround = true
        this.btnMap = false
        this.btnHybrid = false
        this.url = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
      }
      if (url == `map`) {
        var center = this.$refs.myMap.mapObject.getCenter()
        var zoom = this.$refs.myMap.mapObject.getZoom()

        this.btnGround = false
        this.btnMap = true
        this.btnHybrid = false
        this.url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      }
      if (url == `hybrid`) {
        this.btnGround = false
        this.btnMap = false
        this.btnHybrid = true
        this.url = "https://2.aerial.maps.ls.hereapi.com/maptile/2.1/maptile/newest/hybrid.day/{z}/{x}/{y}/256/png8?lg=por&apiKey=U7wvT2IU0rFTeGwMoIpdf7JaQx5QH74SyhG4qiHy7Q8"
        ;
      }
      //else this.url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
    },

    fetchHistoric() {
      const [year, month, day] = this.date.split('-').map(Number);
      const dts = new Date(Date.UTC(year, month - 1, day));

      const dtf = new Date(this.date);
      dtf.setHours(23);
      dtf.setMinutes(59);
      dtf.setDate(dtf.getDate());

      //RESET CHARTS
      this.timeConnectionEngine = [];
      this.engineHistory = [];
      this.timeConnectionVel = [];
      this.velHistory = [];
      this.timeConnectionTransmission = [];
      this.transmissionHistory = [];
      this.timeConnectionOil = [];
      this.oilHistory = [];
      this.timeConnectionCbc = [];
      this.cbcHistory = [];
      this.timeConnectionCbt = [];
      this.cbtHistory = [];

      this.timeConnectionRpm = [];
      this.rpmHistory = [];

      //New Params
      this.timeConnectionPcb = [];
      this.pcbHistory = [];
      this.pomHistory = [];
      this.timeConnectionPom = [];
      this.ptbHistory = [];
      this.timeConnectionPtb = [];
      this.tbtHistory = [];
      this.timeConnectionTbt = [];
      this.aclHistory = [];
      this.timeConnectionAcl = [];
      this.kmhHistory = [];
      this.timeConnectionKmh = [];
      this.cgmHistory = [];
      this.timeConnectionCgm = [];
      this.ttbHistory = []
      this.timeConnectionTtb = []
      this.socHistory = []
      this.timeConnectionSoc = []
      this.tpbHistory = []
      this.timeConnectionTpb = []
      this.tomHistory = []
      this.timeConnectionTom = []
      this.cabHistory = []
      this.timeConnectionCab = []
      this.mkmHistory = []
      this.timeConnectionMkm = []
      this.cfbHistory = []
      this.timeConnectionCfb = []

      this.fetchAssetTelemetry(dts, dtf)
    },

    getDeviceId(assetIdentificator) {

      store.dispatch('app-asset/fetchDevices', {
        page: 1,
        perPage: 10,
        q: assetIdentificator

      }).then(response => {

        if (response && response.data.data.length > 0) {
          this.deviceId = response.data.data[0].id
        }
      });


    },

    fetchAssetTelemetry(dtS, dtE) {
      if (isNaN(dtS.getTime())) return

      const startDate = dtS.toISOString();
      const date = new Date(dtS.toISOString());
      date.setUTCHours(23, 59, 0, 0);
      const endDate = date.toISOString();

      this.telemetryParameters.map(async (p, i) => {
        let page = 1
        let cf = false
        this.loadingHistory = true

        while (cf == false) {
          await store.dispatch('app-asset/fetchAssetTelemetry', {
            id: router.currentRoute.params.id,
            param: this.telemetryParameters[i],
            dtS: startDate,
            dtE: endDate,
            page: page
          }).then(response => {

            if (response && response.data && response.data.data && response.data.data.length > 0) {
              const param = this.telemetryParameters[i];
              const data = response.data.data;

              const deduplicateAndSort = (timeArr, histArr, extractFn) => {
                const map = new Map();
                for (let idx = 0; idx < timeArr.length; idx++) {
                  map.set(timeArr[idx], histArr[idx]);
                }
                for (let k = 0; k < data.length; k++) {
                  const ts = this.parseTelemetryDateTime(data[k].dateTime);
                  const val = extractFn(data[k]);
                  if (!isNaN(ts) && val != null) {
                    map.set(ts, val);
                  }
                }
                const sortedKeys = Array.from(map.keys()).sort((a, b) => a - b);
                timeArr.length = 0;
                histArr.length = 0;
                for (let ts of sortedKeys) {
                  timeArr.push(ts);
                  histArr.push(map.get(ts));
                }
              };

              if (param === 'tpa') {
                deduplicateAndSort(this.timeConnectionEngine, this.engineHistory, item => item.data?.tpa)
              } else if (param === 'tpt') {
                deduplicateAndSort(this.timeConnectionTransmission, this.transmissionHistory, item => item.data?.tpt)
              } else if (param === 'toh') {
                deduplicateAndSort(this.timeConnectionOil, this.oilHistory, item => item.data?.toh)
              } else if (param === 'cbc') {
                deduplicateAndSort(this.timeConnectionCbc, this.cbcHistory, item => item.data?.cbc)
              } else if (param === 'cbt') {
                deduplicateAndSort(this.timeConnectionCbt, this.cbtHistory, item => item.data?.cbt)
              } else if (param === 'rpm') {
                deduplicateAndSort(this.timeConnectionRpm, this.rpmHistory, item => item.data?.rpm)
              } else if (param === 'pcb') {
                deduplicateAndSort(this.timeConnectionPcb, this.pcbHistory, item => item.data?.pcb)
              } else if (param === 'pom') {
                deduplicateAndSort(this.timeConnectionPom, this.pomHistory, item => item.data?.pom)
              } else if (param === 'ptb') {
                deduplicateAndSort(this.timeConnectionPtb, this.ptbHistory, item => item.data?.ptb)
              } else if (param === 'tbt') {
                deduplicateAndSort(this.timeConnectionTbt, this.tbtHistory, item => item.data?.tbt)
              } else if (param === 'kmh') {
                deduplicateAndSort(this.timeConnectionKmh, this.kmhHistory, item => item.data?.kmh)
              } else if (param === 'acl') {
                deduplicateAndSort(this.timeConnectionAcl, this.aclHistory, item => {
                  const acl = item.data?.acl;
                  return acl != null ? Math.trunc(acl * 100) / 100 : null;
                })
              } else if (param === 'cgm') {
                deduplicateAndSort(this.timeConnectionCgm, this.cgmHistory, item => item.data?.cgm)
              } else if (param === 'ttb') {
                deduplicateAndSort(this.timeConnectionTtb, this.ttbHistory, item => item.data?.ttb)
              } else if (param === 'soc') {
                deduplicateAndSort(this.timeConnectionSoc, this.socHistory, item => item.data?.soc)
              } else if (param === 'tpb') {
                deduplicateAndSort(this.timeConnectionTpb, this.tpbHistory, item => item.data?.tpb)
              } else if (param === 'tom') {
                deduplicateAndSort(this.timeConnectionTom, this.tomHistory, item => item.data?.tom)
              } else if (param === 'cab') {
                for (let j = 0; j < data.length; j++) {
                  this.timeConnectionCab.push(this.getHoursAndMinutes(data[j].dateTime))
                  this.cabHistory.push(data[j].data?.cab || 0)
                }
              } else if (param === 'mkm') {
                for (let j = 0; j < data.length; j++) {
                  this.timeConnectionMkm.push(this.getHoursAndMinutes(data[j].dateTime))
                  this.mkmHistory.push(data[j].data?.mkm || 0)
                }
              } else if (param === 'cfb') {
                for (let j = 0; j < data.length; j++) {
                  this.timeConnectionCfb.push(this.getHoursAndMinutes(data[j].dateTime))
                  this.cfbHistory.push(data[j].data?.cfb || 0)
                }
              }

            } else {
              this.loadingHistory = false
              cf = true
            }
            page++

          });

        }
      });
    },

    event_tlm: function (content) {
      const telemetryData = content?.data || {}
      const timestamp = content?.deviceDateTime
      const ioPayload = {
        ...telemetryData,
        ou1: content?.ou1 ?? telemetryData?.ou1,
        ou2: content?.ou2 ?? telemetryData?.ou2,
        ou3: content?.ou3 ?? telemetryData?.ou3,
        ou4: content?.ou4 ?? telemetryData?.ou4,
        in1: content?.in1 ?? telemetryData?.in1,
        in2: content?.in2 ?? telemetryData?.in2,
        in3: content?.in3 ?? telemetryData?.in3,
        in4: content?.in4 ?? telemetryData?.in4,
      }

      // Atualização de parâmetros de telemetria via SignalR desabilitada
      this.updateIoFromTelemetry(ioPayload)

      if (Object.prototype.hasOwnProperty.call(telemetryData, 'pan')) {
        this.panic = telemetryData.pan
      }

      var panic = {
        assetId: content.assetId,
        pan: null,
      }

      if (content.data && content.data.pan != undefined) {
        panic.pan = content.data.pan
      }

      var piv = {
        assetId: content.assetId,
        inOut: content.data || null,
      }

      var asset = {
        id: content.assetId,
        lastLat: content.lat,
        lastLng: content.lng,
        lastKmh: content.kmh,
        lastPositionTime: content.deviceDateTime,
        lastWorkstatus: content.workStatus,

        lastkmh: content.lastkmh,
        hor: content.data.hor,
        hrb: content.data.hrb,
        hod: content.data.hod,
        cbc: content.data.cbc,
        tpa: content.data.tpa,
        tpt: content.data.tpt,
        toh: content.data.toh,
        mta: content.data.mta,
        mcc: content.data.mcc,
        mth: content.data.mth,
        mtt: content.data.mtt,
        btf: content.data.btf,
        cbt: content.data.cbt,
        rpm: content.data.rpm,
        cgm: content.data.cgm,

        pcb: content.data.pcb,
        pom: content.data.pom,
        ptb: content.data.ptb,
        tbt: content.data.tbt,
        acl: content.data.acl,
        kmh: content.data.kmh,

        soc: content.data.soc,
        soh: content.data.soh,
        ttb: content.data.ttb,
        tpb: content.data.tpb,
        ctr: content.data.ctr,
        tom: content.data.tom,
        dtc: content.data.dtc,
        tct: content.data.tct,
      }

      var outputs = {
        assetId: content.assetId,
        ou1: content.ou1,
        ou2: content.ou2,
        ou3: content.ou3,
        out: content.ou4
      }

      var inputs = {
        assetId: content.assetId,
        in1: content.in1,
        in2: content.in2,
        in3: content.in3,
        in4: content.in4
      }

      let block = {
        assetId: content.assetId,
        ou1: content.data.ou1
      }

      this.realtimeUpdatePan(panic);
      this.realtimeUpdateAsset(asset);
      this.realtimeUpdateOutput(outputs);
      this.realtimeUpdateInput(inputs);
      this.realtimeUpdateBlock(block)
      this.realtimeUpdatePivo(piv)

    },

    realtimeUpdateBlock(block) {
      if (!block || !block.assetId || block.ou1 == null) return
      if (router.currentRoute.params.id === block.assetId) {
        this.isBlocked = block.ou1 === 1
      }
    },


    realtimeUpdatePivo(piv) {
      if (piv == null || piv.assetId == undefined || piv.assetId == null || piv.inOut == undefined || piv.inOut == null || JSON.stringify(piv.inOut) === '{}') return

      var self = this;
      if (router.currentRoute.params.id == piv.assetId) {

        if ((piv.inOut.sse == undefined || piv.inOut.sse == null) && (piv.inOut.ssd == undefined || piv.inOut.ssd == null)) {

          this.sse = false
          this.ssd = false

          this.in1 = piv.inOut.in1
          this.in2 = piv.inOut.in2

          if (piv.inOut.ou1 != this.oldOldOut1) {
            this.out1 = piv.inOut.ou1
            this.oldOldOut1 = this.out1
          }
          if (piv.inOut.ou2 != this.oldOldOut2) {
            this.out2 = piv.inOut.ou2
            this.oldOldOut2 = this.out2
          }
          if (piv.inOut.ou3 != this.oldOldOut3) {
            this.out3 = piv.inOut.ou3
            this.oldOldOut3 = this.out3
          }

          if (piv.inOut.ou4 && piv.inOut.ou4 != this.oldInputRange01) {
            this.inputRange01 = piv.inOut.ou4
            this.oldInputRange01 = this.inputRange01
          }
          if (piv.inOut.ou1 == this.out1 && piv.inOut.ou2 == this.out2 && piv.inOut.ou3 == this.out3 && piv.inOut.ou4 == this.inputRange01) {
            this.isLoadingGlobal = false
            this.waitingCommandResponse = false
          }

        } else {
          this.ssd = piv.inOut.ssd
          this.sse = piv.inOut.sse
        }
      }
    },

    registerEventBusListeners: function () {
      this.$root.$on("tlm", this.event_tlm);
    },

    deregisterEventBusListeners: function () {
      this.$root.$off("tlm", this.event_tlm);
    },

    realtimeUpdatePan(panic) {

      if (panic == null || panic.assetId == undefined || panic.assetId == null || panic.pan == undefined || panic.pan == null) return

      var self = this;
      if (router.currentRoute.params.id == panic.assetId) {

        self.panic = panic.pan;
      }
    },

    realtimeUpdateInput: function (inputs) {

      if (inputs == null || inputs.assetId == undefined || inputs.assetId == null) return;

      var self = this;

      if (router.currentRoute.params.id == inputs.assetId) {

        if (inputs.in1) self.input01 = inputs.in1 = 1 ? true : false
        if (inputs.in2) self.input02 = inputs.in2 = 1 ? true : false
        if (inputs.in3) self.input03 = inputs.in3 = 1 ? true : false
        if (inputs.in4) self.input04 = inputs.in4 = 1 ? true : false

      }

    },

    realtimeUpdateOutput: function (outputs) {

      if (outputs == null || outputs.assetId == undefined || outputs.assetId == null) return;

      var self = this;

      if (router.currentRoute.params.id == outputs.assetId) {

        if (outputs.ou1) {
          if (outputs.ou1 == self.out1) {
            self.isLoadingOut1 = false;
            self.isLoadingGlobal = false;
          }
          self.out1 = outputs.ou1 = 1 ? true : false
        }
        if (outputs.ou2) {
          if (outputs.ou2 == self.out2) {
            self.isLoadingOut2 = false;
            self.isLoadingGlobal = false;
          }
          self.out2 = outputs.ou2 = 1 ? true : false
        }
        if (outputs.ou3) {
          if (outputs.ou3 == self.out3) {
            self.isLoadingOut3 = false;
            self.isLoadingGlobal = false;
          }
          self.out3 = outputs.ou3 = 1 ? true : false
        }

        if (outputs.ou4) self.out4 = outputs.ou4
      }

    },

    realtimeUpdateAsset: function (asset) {


      if (asset == null || asset == undefined || asset.id == undefined) return;
      var self = this;

      if (router.currentRoute.params.id == asset.id) {

        if (asset.lastLat && asset.lastLng) {
          self.latLong = this.verifyLatLng(asset.lastLat, asset.lastLng, self.latLong)
          if (this.$refs.myMap?.mapObject) {
            this.$refs.myMap.mapObject.setView(this.latLong);
          }
        }

        if (asset.lastPositionTime) self.lastConnectionTime = this.formatDate(asset.lastPositionTime);

        if (asset.lastWorkstatus) this.lastWorkStatus = asset.lastWorkstatus;

        if (asset.data) {
          // Atualização de parâmetros de telemetria via SignalR desabilitada
          //this.updateIoFromTelemetry(asset.data)
        }
      }

    },

    verifyLatLng(lat, lng, standart) {
      if (lat && lat != 0 && lng && lng != 0) return [lat, lng]
      return standart
    },


    formatDate(myDate) {

      const d = new Date(myDate);
      let dt = d.toLocaleDateString();

      const hm = d.toLocaleTimeString().substring(0, 5)

      return `${dt} - ${hm}`;

      //return `${dt} - ${d.getHours()}:${d.getMinutes()}`
    },

    getHoursAndMinutes(dateString) {
      const dt = new Date(dateString);

      const dtFormat = dt.toLocaleTimeString().substring(0, 5)

      return dtFormat;
    },

    parseTelemetryDateTime(value) {
      if (value == null) return NaN;
      if (typeof value === 'number') {
        return value < 1e12 ? value * 1000 : value;
      }
      return new Date(value).getTime();
    },

    // A função resolveIcon agora é importada do utilitário compartilhado
    resolveIcon

  },
  setup(props, { root }) {
    const ASSET_APP_STORE_MODULE_NAME = 'app-asset'
    const dts = new Date();
    dts.setHours(0);
    dts.setMinutes(0);

    const dataWorkStatus = ref([]);
    const myId = router.currentRoute.params.id
    const user = localStorage.userData != undefined ? JSON.parse(localStorage.userData) : {}

    const plan = ref(null)
    const telemetrySnapshot = ref({})
    const telemetrySummaryData = ref([])
    const telemetrySummaryLoading = ref(false)

    const PARAMETER_META = {
      kmh: { icon: 'ActivityIcon', unit: 'Km/h', color: 'info' },
      hor: { icon: 'ClockIcon', unit: 'Hours', color: 'info' },
      hrb: { icon: 'ClockIcon', unit: 'Hours', color: 'info' },
      hod: { icon: 'AirplayIcon', unit: 'Km', color: 'info' },
      cbc: { icon: 'DropletIcon', unit: 'L/h', color: 'info', decimals: 1 },
      tpa: { icon: 'ThermometerIcon', unit: 'ºC', color: 'info' },
      tda: { icon: 'ThermometerIcon', unit: 'ºC', color: 'info' },
      pda: { icon: 'InfoIcon', unit: 'psi', color: 'info' },
      tpt: { icon: 'ThermometerIcon', unit: 'ºC', color: 'info' },
      toh: { icon: 'ThermometerIcon', unit: 'ºC', color: 'info' },
      rpm: { icon: 'RotateCwIcon', unit: 'r/min', color: 'info' },
      cgm: { icon: 'ZapIcon', unit: '%', color: 'info' },
      mta: { icon: 'ThermometerIcon', unit: 'ºC', color: 'info' },
      mcc: { icon: 'DropletIcon', unit: 'L/h', color: 'info' },
      mth: { icon: 'ThermometerIcon', unit: 'ºC', color: 'info' },
      mtt: { icon: 'ThermometerIcon', unit: 'ºC', color: 'info' },
      pcb: { icon: 'InfoIcon', unit: 'kPa', color: 'info' },
      pom: { icon: 'InfoIcon', unit: 'kPa', color: 'info' },
      ptb: { icon: 'InfoIcon', unit: 'kPa', color: 'info' },
      tbt: { icon: 'InfoIcon', unit: 'Volts', color: 'info' },
      acl: { icon: 'InfoIcon', unit: 'G', color: 'info', decimals: 2 },
      soc: { icon: 'InfoIcon', unit: '%', color: 'info' },
      soh: { icon: 'InfoIcon', unit: '%', color: 'info' },
      ttb: { icon: 'InfoIcon', unit: 'Volts', color: 'info' },
      tpb: { icon: 'InfoIcon', unit: 'ºC', color: 'info' },
      tom: { icon: 'ThermometerIcon', unit: 'ºC', color: 'info' },
      ctr: { icon: 'InfoIcon', unit: 'Pulses', color: 'info' },
      btf: { icon: 'BatteryChargingIcon', unit: '⚠️', color: 'warning', valueLabelKey: 'Low Battery' },
      cbt: { icon: 'DropletIcon', unit: '%', color: 'info', component: 'gauge' },
      tct: { icon: 'InfoIcon', unit: '', color: 'info', hideValue: true },
      bus: { icon: 'CompassIcon', unit: '°', color: 'info' },
      prh: { icon: 'TargetIcon', unit: 'kPa', color: 'info' },
      acx: { icon: 'TrendingUpIcon', unit: 'm/s²', color: 'info', decimals: 2 },
      acy: { icon: 'TrendingUpIcon', unit: 'm/s²', color: 'info', decimals: 2 },
      acz: { icon: 'TrendingUpIcon', unit: 'm/s²', color: 'info', decimals: 2 },
      ilt: { icon: 'ArrowUpRightIcon', unit: '°', color: 'info' },
    }

    const formatTimestamp = (dateString) => {
      if (!dateString) return ''
      const ddmmyyyyPattern = /^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})$/
      const match = dateString.match(ddmmyyyyPattern)
      let date
      if (match) {
        const [, day, month, year, hour, minute] = match
        date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(minute))
      } else {
        date = new Date(dateString)
      }

      if (!date || Number.isNaN(date.getTime())) return dateString || ''

      try {
        return date.toLocaleString(undefined, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      } catch (error) {
        return dateString || ''
      }
    }

    const formatValue = (rawValue, meta) => {
      if (rawValue === null || rawValue === undefined) return ''
      const numericValue = Number(rawValue)
      const isNumeric = !Number.isNaN(numericValue)

      if (isNumeric) {
        if (meta && typeof meta.decimals === 'number') {
          return numericValue.toFixed(meta.decimals)
        }
        return numericValue
      }
      return rawValue
    }

    const resolveTelemetryDate = (date) => {
      if (!date) return null
      if (date instanceof Date) {
        return Number.isNaN(date.getTime()) ? null : date
      }
      const parsed = new Date(date)
      return Number.isNaN(parsed.getTime()) ? null : parsed
    }

    const formatTelemetryTimestamp = (entry) => {
      if (!entry) return ''
      const date = entry.receivedAt || resolveTelemetryDate(entry.parameterDate)
      if (!date) return ''

      try {
        return date.toLocaleString(undefined, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      } catch (error) {
        return ''
      }
    }

    const normalizeTelemetryValue = (code, value) => {
      const meta = telemetryParameterMap[code]
      if (!meta) return value

      if (value === null || value === undefined) return value

      switch (meta.type) {
        case 'int':
        case 'double':
        case 'decimal': {
          const numericValue = Number(value)
          return Number.isNaN(numericValue) ? value : numericValue
        }
        case 'bool':
          if (typeof value === 'boolean') return value
          if (typeof value === 'number') return value === 1
          if (typeof value === 'string') {
            const lowered = value.toLowerCase()
            if (lowered === 'true') return true
            if (lowered === 'false') return false
            const numeric = Number(value)
            if (!Number.isNaN(numeric)) return numeric === 1
          }
          return Boolean(value)
        default:
          return value
      }
    }

    const updateTelemetryEntry = (code, value, options = {}) => {
      const meta = telemetryParameterMap[code] || {}
      const existing = telemetrySnapshot.value[code] || {}

      const parameterDate = options.parameterDate ?? existing.parameterDate ?? null
      const receivedAt = resolveTelemetryDate(options.receivedAt)
          || resolveTelemetryDate(parameterDate)
          || existing.receivedAt
          || null

      const entry = {
        value,
        description: options.description ?? existing.description ?? meta.description ?? '',
        type: options.type ?? existing.type ?? meta.type ?? '',
        parameterDate,
        receivedAt,
      }

      root.$set(telemetrySnapshot.value, code, entry)
    }

    const applyTelemetrySnapshot = (entries = []) => {
      if (!Array.isArray(entries)) return
      entries.forEach(entry => {
        updateTelemetryEntry(entry.code, entry.value, {
          description: entry.description,
          type: entry.type,
          parameterDate: entry.parameterDate,
          receivedAt: entry.receivedAt,
        })
      })
    }

    const applyRealtimeTelemetryData = (telemetryData = {}, timestamp) => {
      if (!telemetryData || typeof telemetryData !== 'object') return
      const parsedTimestamp = resolveTelemetryDate(timestamp) || new Date()

      Object.entries(telemetryData).forEach(([key, value]) => {
        if (!telemetryParameterMap[key]) return
        const normalizedValue = normalizeTelemetryValue(key, value)
        updateTelemetryEntry(key, normalizedValue, {
          parameterDate: timestamp,
          receivedAt: parsedTimestamp,
        })
      })
    }

    const getTelemetryEntry = (code) => {
      return telemetrySnapshot.value[code] || null
    }

    const getTelemetryValue = (code, fallback = '') => {
      const entry = getTelemetryEntry(code)
      if (!entry || entry.value === null || entry.value === undefined) return fallback
      return entry.value
    }

    const getTelemetryTimestamp = (code) => {
      const entry = getTelemetryEntry(code)
      if (!entry) return ''
      return formatTelemetryTimestamp(entry)
    }

    const fetchTelemetrySummary = () => {
      telemetrySummaryLoading.value = true
      return store
          .dispatch('app-asset/fetchAssetSummaryParameter', { assetId: myId })
          .then(response => {
            const rawData = response?.data?.data || []
            telemetrySummaryData.value = rawData

            const telemetryData = processTelemetryData(rawData)
            applyTelemetrySnapshot(telemetryData)
          })
          .catch(() => {})
          .finally(() => {
            telemetrySummaryLoading.value = false
          })
    }

    const telemetryCards = computed(() => {
      return telemetrySummaryData.value
        .map(item => {
          const code = item.parameterName
          const meta = PARAMETER_META[code] || {}

          const rawValue = item.parameterValue
          const numericValue = Number(rawValue)
          const isNumeric = !Number.isNaN(numericValue)
          const isZeroValue = (isNumeric && numericValue === 0) || rawValue === 0 || rawValue === '0'

          if (isZeroValue) return null
          if (code === 'btf' && !rawValue) return null
          if (code === 'tct' && (!rawValue || numericValue <= 1)) return null

          const timestamp = formatTimestamp(item.parameterDate)

          if (code === 'cbt') {
            if (!isNumeric || numericValue <= 0) return null
            return {
              code,
              component: 'gauge',
              title: item.parameterLabel,
              value: numericValue,
              timestamp,
            }
          }

          let icon = meta.icon || 'InfoIcon'
          let color = meta.color || 'info'

          if (code === 'tct') {
            const failureType = numericValue
            const planId = plan.value?.id
            if (planId && planId > 1) {
              if (failureType == 2) {
                icon = 'AlertTriangleIcon'
                color = 'warning'
              } else if (failureType == 3) {
                icon = 'XOctagonIcon'
                color = 'danger'
              }
            }
          }

          const valueFormatted = meta.hideValue ? '' : formatValue(rawValue, meta)

          return {
            code,
            component: 'simple',
            title: item.parameterLabel,
            icon,
            color,
            value: meta.valueLabelKey ? root.$t(meta.valueLabelKey) : valueFormatted,
            unit: meta.unitLabel ? root.$t(meta.unitLabel) : (meta.unit || ''),
            timestamp,
          }
        })
        .filter(card => card !== null)
    })

    const hasTelemetryCards = computed(() => telemetryCards.value.length > 0)

    // Register module
    if (!store.hasModule(ASSET_APP_STORE_MODULE_NAME)) store.registerModule(ASSET_APP_STORE_MODULE_NAME, assetStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ASSET_APP_STORE_MODULE_NAME)) store.unregisterModule(ASSET_APP_STORE_MODULE_NAME)
    })

    function utcToLocalDate(date) {
      return date.getTime()
    }

    function parseDateWithoutTimezone(dateString) {
      const [datePart, timePart] = dateString.split("T");
      const [year, month, day] = datePart.split("-").map(Number);
      const [hour, minute, second] = timePart.split(":").map(Number);

      const date = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
      return date.getTime()
    }

    function resolveColor(status) {

      if (!status) return '#f3f2f7'
      if (status === 'failure') return '#ea5455'
      if (status === 'off') return '#82868b'
      if (status === 'noconnection') return '#f3f2f7'
      if (status === 'severe') return '#ff9f43'
      if (status === 'iddle') return '#00cfe8'
      if (status === 'on') return '#28c76f'
      return '#28c76f'
    }

    store
        .dispatch('app-asset/fetchAssetWorkstatusHistory', {
          id: router.currentRoute.params.id,
          dt: dts.toISOString()

        })
        .then(response => {

          for (var i = ref(0); i.value < response.data.data.length; i.value++) {

            const status = ref(null);

            status.value = {
              name: response.data.data[i.value].workStatus,
              data: [{
                x: 'Status',
                y: [
                  //parseDateWithoutTimezone(response.data.data[i.value].start),
                  //parseDateWithoutTimezone(response.data.data[i.value].end)
                  new Date(response.data.data[i.value].start + "Z").getTime(),
                  new Date(response.data.data[i.value].end + "Z").getTime()
                ],

                fillColor: resolveColor(response.data.data[i.value].workStatus)

              },

              ]
            };

            dataWorkStatus.value.push(status.value);


          }


        })
        .catch(() => {})
    
    const toAssetSummary = () => {
      router.push({ name: 'apps-asset-summary', params: { id: myId } })
    }

    return {
      ASSET_APP_STORE_MODULE_NAME,
      dts,
      dataWorkStatus,
      resolveColor,
      utcToLocalDate,
      myId,
      user,
      toAssetSummary,
      plan,
      telemetrySnapshot,
      telemetrySummaryLoading,
      telemetryCards,
      hasTelemetryCards,
      fetchTelemetrySummary,
      getTelemetryValue,
      getTelemetryEntry,
      getTelemetryTimestamp,
      applyTelemetrySnapshot,
      updateTelemetryEntry,
      applyRealtimeTelemetryData,
      normalizeTelemetryValue
    }

  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/map-leaflet.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.someExtraClass {
  //background-color: #28c76f;
  padding: 4px;
  border-radius: 50px 50px 50px 50px;
  box-shadow: 5px 3px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: auto !important;
  height: auto !important;
}

.pulsar {
  animation: pulse-opacity 1.8s infinite;
}

@keyframes pulse-opacity {
  0%, 100% {
    box-shadow: 0 0 5px 2px rgba(255, 0, 0, 0.3);
  }
  50% {
    box-shadow: 0 0 10px 5px rgba(255, 0, 0, 0.5);
  }
}


.asset-on {
  background-color: #28c76f !important;
}

.asset-off {
  background-color: #82868b !important;
}

.asset-failure {
  background-color: #ef5258 !important;
}

.asset-noconnection {
  background-color: #f5f4f8 !important;
}

.asset-severe {
  background-color: #ff9d54 !important;
}

.asset-iddle {
  background-color: #00cfe8 !important;
}

.with-icon {
  width: 40px;
}

.vue2leaflet-map {
  &.leaflet-container {
    height: 445px;
  }
}

.text-header {
  //font-size: clamp(0.5em, 0.7em + 0.2vw, 5.5em);
  font-size: 1em;
}

//@media
@media screen and (max-width: 540px) {
  .text-header {
    font-size: 0.8em;
  }
}

@media (max-width: 576px) {
  .custom-h5 {
    font-size: 12px !important;
    /* Defina o tamanho da fonte desejado para telas sm ou menores */
  }
}
</style>
<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>
